module.exports = __webpack_public_path__ + "img/icon-gear.d8903de2.svg";